import {useCallback, useSyncExternalStore} from 'react'

export type Platform = 'windows' | 'mac'

function getPlatform(): Platform | null {
  if (typeof navigator === 'undefined') {
    return null
  } else if (/Windows/.test(navigator.userAgent)) {
    return 'windows'
  } else if (/Macintosh/.test(navigator.userAgent)) {
    return 'mac'
  }
  return null
}

// Platform never changes during runtime, so no-op subscribe
function subscribe() {
  return () => {}
}

// Server always returns false
function getServerSnapshot() {
  return false
}

/**
 * SSR-friendly hook to retrieve information about the user platform.
 *
 * @param platforms @type {Array<Platform>} platforms to check
 * @returns {boolean} true if user platform matches one of the provided platforms.
 */
export function useIsPlatform(platforms: Platform[]): boolean {
  return useSyncExternalStore(
    subscribe,
    useCallback(() => {
      const platform = getPlatform()
      return platform !== null && platforms.includes(platform)
    }, [platforms]),
    getServerSnapshot,
  )
}
